import { ProductSearchCondition } from "../types/page";
import { MainApi } from "./MainApi";

export class ProductApi {
  static baseUrl = `${MainApi.urlPrefix}/user/product`;

  static getTheLatestProduct = (condition: ProductSearchCondition) => () =>
    MainApi.api.get(
      `${ProductApi.baseUrl}/the-latest${MainApi.toParamStringFromObject({
        ...condition,
        display_position: "USER_WEB_KPASS",
      })}`
    );

  static getProductImages = (condition: ProductSearchCondition) => () =>
    MainApi.api.get(
      `${ProductApi.baseUrl}/${condition?.productIdx}/image${MainApi.toParamStringFromObject({
        ...condition,
        display_position: "USER_WEB_KPASS",
      })}`
    );
}
